import React from 'react';

const Footer = () => (
  <div className="container footer" id="footer">
    &copy; 2018 StackOverFlow-Lite
  </div>
);

export default Footer;
